// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "Footer-module--wrapper--EPnCm";
export var leftBlock = "Footer-module--leftBlock--Hzez-";
export var title = "Footer-module--title--zZr-3";
export var sectors = "Footer-module--sectors--NI4Rk";
export var copyRightsWrapper = "Footer-module--copyRightsWrapper--jD3P4";
export var copy = "Footer-module--copy--2t3H0";
export var rightBlock = "Footer-module--rightBlock--ovbnM";
export var infoWrapper = "Footer-module--infoWrapper--U8Xm9";
export var address = "Footer-module--address--mMOPG";
export var aboutWebfolio = "Footer-module--aboutWebfolio--yX4Ab";
export var bigTriangle = "Footer-module--bigTriangle--G2DQ8";
export var smallTriangle = "Footer-module--smallTriangle--jsh0a";
export var link = "Footer-module--link--HfQxQ";